export const marketingLink = "https://dna.digitalnewagency.com/en/marketing/";
export const technologyLink = "https://dnatechnology.io/";
